import { render, staticRenderFns } from "./NotificationSetup.vue?vue&type=template&id=5170d18a&scoped=true"
import script from "./NotificationSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSetup.vue?vue&type=style&index=0&id=5170d18a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170d18a",
  null
  
)

export default component.exports